// tslint:disable
/**
 * CONEXSYS Lead Portal API
 * The API for the CONEXSYS Lead Portal
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: support@conexsys.com
 *
 * CONTEXT: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { leadConfig as config } from '../../../config/lead';
import { apiRequest, setEntitiesApiOperationState } from '../../../app/api';
import { ContextHelper } from '../classes';
import moment from 'moment';
import _ from 'lodash';

import { ContextEntity, ContextEntities } from '../collections';
import { State_ApiOperationContextTypes } from '../../../storage';
import { UseCtx } from '../../../config/hooks';
import { modifyEntity } from '../../../app/utils';

export enum ContextApiOperation {
	readContexts = 'readContexts',
	readContextsAll = 'readContextsAll',
	writeContexts = 'writeContexts'
}

export interface ReadContextsRequest {
	userId: string;
	queryLimit?: number;
	queryBookmark?: string;
	modifiedFrom?: string;
	modifiedTo?: string;
	ids?: string[];
}

export interface ReadContextsAllRequest {
	userId: string;
	queryLimit?: number;
	queryBookmark?: string;
	modifiedFrom?: string;
	modifiedTo?: string;
	ids?: string[];
	eventIds?: string[];
}

export interface WriteContextsRequest {
	userId: string;
	contexts: ContextEntities;
}

/**
 * Read contexts
 */
export async function readContexts(
	ctx: UseCtx<any>,
	requestParameters: ReadContextsRequest
): Promise<ContextEntities> {
	const operationId = ContextApiOperation.readContexts,
		requestId = 'default';

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// make the api request
	const response = await apiRequest<ContextEntities, ReadContextsRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters
	);

	let entities: ContextEntities | undefined = response.response.data;
	if (!entities) entities = [];

	// patch entities states with an api success data for the operation
	setEntitiesApiOperationState<ContextEntities, ContextHelper>(
		ctx.lead.context,
		entities,
		operationId,
		requestId,
		State_ApiOperationContextTypes.Success,
		attemptDate
	);

	// upsert the entities to the store
	ctx.lead.context.upsert(entities);

	// return the entities to the caller for direct reference
	return entities;
}

/**
 * Read contexts all
 */
export async function readContextsAll(
	ctx: UseCtx<any>,
	requestParameters: ReadContextsAllRequest
): Promise<ContextEntities> {
	const operationId = ContextApiOperation.readContextsAll,
		requestId = 'default';

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// make the api request
	const response = await apiRequest<ContextEntities, ReadContextsAllRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters
	);

	let entities: ContextEntities | undefined = response.response.data;
	if (!entities) entities = [];

	// patch entities states with an api success data for the operation
	setEntitiesApiOperationState<ContextEntities, ContextHelper>(
		ctx.lead.context,
		entities,
		operationId,
		requestId,
		State_ApiOperationContextTypes.Success,
		attemptDate
	);

	// upsert the entities to the store
	ctx.lead.context.upsert(entities);

	// return the entities to the caller for direct reference
	return entities;
}

/**
 * Write Contexts
 */
export async function writeContexts<T>(
	ctx: UseCtx<any>,
	requestParameters: WriteContextsRequest
): Promise<ContextEntities> {
	const operationId = ContextApiOperation.writeContexts,
		requestId = 'default';

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// update each entities modified info
	requestParameters.contexts.forEach(
		(entity: ContextEntity, i: number, a: ContextEntities) => {
			a[i] = modifyEntity<ContextEntity>(ctx, entity);
		}
	);

	// make the api request
	const response = await apiRequest<ContextEntities, WriteContextsRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters,
		'contexts'
	);

	let entities: ContextEntities | undefined = response.response.data;
	if (!entities) entities = [];

	// patch entities states with an api success data for the operation
	setEntitiesApiOperationState<ContextEntities, ContextHelper>(
		ctx.lead.context,
		entities,
		operationId,
		requestId,
		State_ApiOperationContextTypes.Success,
		attemptDate
	);

	// upsert the entities to the store
	ctx.lead.context.upsert(entities);

	// return the entities to the caller for direct reference
	return entities;
}
